import React, { useState, useEffect } from "react";
import { useParams,useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import deleteIcon from "../../../img/icon/icon-delete.svg";

import HeaderTitle from "../includes/HeaderTitle";
import { escapeHtml,unescapeHtml,ChangeDateStringOnlyDate,ChangeSearchingDateFormat } from "../../../components/common/Common";

//자료실 정보 편집
function ReferenceRoomDetail({setMenuItem}) {
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  const admin_name = localStorage.getItem('adminName');
  let { rr_idx } = useParams();
  const navigate = useNavigate();

  //자료실 변수 저장 객체
  const newData = {      
    rr_idx: 0,
    mem_idx: admin_idx,
    mem_name: admin_name,
    rr_read: 0,
    rr_title: "",
    rr_comment: "",
    rr_rdate: ChangeSearchingDateFormat(new Date(),'.'),
    rr_hits: 0,
    rr_status:1
  };

  //자료실정보
  const [varReferenceRoomInfo,setReferenceRoomInfo] = useState({});
  const [varReferenceRoomFiles,setReferenceRoomFiles] = useState([]);
  const [varReferenceFiles,setReferenceFiles] = useState([]);
  
  //자료실정보 읽어오기
  const getReferenceRoomInformation = async () => {
    if(Number(rr_idx) === 0) {
      setReferenceRoomInfo(newData);
    //자료실 정보를 서버로부터 읽어오기
    } else {
      var sendData = {rr_idx: rr_idx,};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/_get_referenceroom_information`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          if(datas.results?.length > 0) {
            setReferenceRoomInfo(datas.results[0]);
            setReferenceRoomFiles(datas.files);
          }
        }
      });
    }
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuItem('ReferenceRoomList');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getReferenceRoomInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rr_idx]);

  //회원정보편집
  const onReferenceRoomInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "rr_title" || name === "rr_comment" || name === "rr_answer")
      setReferenceRoomInfo({...varReferenceRoomInfo, [name]:escapeHtml(value)});
    else if(name === 'rr_read')
      setReferenceRoomInfo({...varReferenceRoomInfo, [name]:Number(value)});
    else 
      setReferenceRoomInfo({...varReferenceRoomInfo, [name]:value});
  }

  //첨부파일 추가 ----------------------------------------------------------------------------------------
  const onSelectedFilesHandler = (e) => {
    const files = e.currentTarget.files;
    console.log(files);
    let curFileList = [...varReferenceFiles];
    for(var i=0; i < files.length; i++) {
      curFileList = curFileList.concat(files[i]);
      console.log(curFileList);   
    }
    setReferenceFiles(curFileList);
  }
  //비저장된 첨부파일 삭제
  const onDeleteFileHandler = (e,index) => {
    e.preventDefault();
    
    let fileArray = [...varReferenceFiles];
    fileArray.splice(index,1);
    setReferenceFiles(fileArray);
  }

  //저장된 첨부파일 삭제
  const onDeletePhotoHandler = async (e,rp_idx) => {
    e.preventDefault();
    //저장된 파일 삭제 
    const delDatasList = varReferenceRoomFiles.filter(el=>el.rp_idx===rp_idx);

    if(!window.confirm(delDatasList.rp_name+'을 삭제합니까?')) return false;

    //데이타베이스에서 삭제
    const sendData = {rp_idx:rp_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_referenceroom_files`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 0){
        const datasList = varReferenceRoomFiles.filter(el=>el.rp_idx!==rp_idx);
        setReferenceRoomFiles(datasList);
      } 
      alert(datas.message);
    });
  }

  //게시판정보 저장
  const onUpdateReferenceRoomHandler = async (e) => {
    let fileRealNames = [];
    //서버로 업로드할 매물사진을 배열로 저장
    const newPhotoMax = varReferenceFiles?.length;
    let PhotoForm = new FormData();
    for(var i=0; i < newPhotoMax; i++) {
      PhotoForm.append('referenceroom',varReferenceFiles[i]);
      fileRealNames.push(varReferenceFiles[i].name);
    }

    let prompt = "현재 선택된 자료의 정보를 저장합니까?";
    if(varReferenceRoomInfo.rr_idx === 0)  prompt = "입력하신 자료를 등록합니까?";
    if(!window.confirm(prompt)) return false;

    if(newPhotoMax > 0) {
      await axios.post(`${process.env.REACT_APP_HOST}/referenceroomArray`, PhotoForm).then((res) => {
        console.log(res.data);
        if(res.data.retvalue === 1) {
          const fileNames = res.data.fileNames; //배열
          console.log(fileNames);
          //공지사항+첨부파일 DB 등록
          UpdateDataToServer(fileRealNames,fileNames);
        }
      });
    } else {
      UpdateDataToServer('','');
    }
  }
  //자료실정보 저장
  const UpdateDataToServer = async (fileRealNames,fileNames) => {
    const sendData = {boardInfo:varReferenceRoomInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_referenceroom_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(fileNames === "") {
          //목록페이지로 이동
          navigate(`/Admin/Boards/ReferenceRoomList`);
        } else {
          const rr_idx = datas.rr_idx;
          InsertReferenceRoomFiles(rr_idx,fileRealNames,fileNames);
        }
      } else {
        alert(datas.message);
      }
    });
  }
  //첨부파일저장
  const InsertReferenceRoomFiles = async(rr_idx,fileRealNames,fileNames) => {
    const sendData = {rr_idx:rr_idx,fileRealNames:fileRealNames,fileNames:fileNames};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_referenceroom_files`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //목록페이지로 이동
        navigate(`/Admin/Boards/ReferenceRoomList`);
      } else {
        alert(datas.message);
      }
    });
  } 

  return (        
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="게시판 관리" varPageTitle={varReferenceRoomInfo.rr_idx===0?"자료실등록":"자료살상세"}/>
      <div className="admin-content">
        <div className="main-box">
          <table className="write">
            <colgroup><col width="30%"></col><col width="70%"></col></colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>등록일자</th>
                <td>{ChangeDateStringOnlyDate(varReferenceRoomInfo.rr_rdate||"")}</td>
              </tr>
              <tr>
                <th>등록자</th>
                <td>{varReferenceRoomInfo.mem_name||""}</td>
              </tr>
              <tr>
                <th>열람권한</th>
                <td>
                  <select value={varReferenceRoomInfo.rr_read} name="rr_read" style={{width:"120px"}} onChange={(e)=>onReferenceRoomInfoHandler(e)}>
                    <option value={0}>공통</option>
                    <option value={1}>기사</option>
                    <option value={2}>직원</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>제목</th>
                <td><input type="text" name="rr_title" value={unescapeHtml(varReferenceRoomInfo.rr_title||"")} onChange={(e)=>onReferenceRoomInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>내용</th>
                <td><textarea name="rr_comment" style={{maxWidth:"100%"}} value={unescapeHtml(varReferenceRoomInfo.rr_comment||"")} onChange={(e)=>onReferenceRoomInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>첨부파일</th>
                <td>
                  {varReferenceRoomFiles.map((files,i)=>(
                    <div key={'files_'+i} className="file-list">
                      <span>{files.rp_name}</span>
                      <button className="deleteBtn2" onClick={e=>onDeletePhotoHandler(e,files.rp_idx)}><img src={deleteIcon} alt=""/></button>
                    </div>
                  ))}
                  {varReferenceFiles.map((files,i)=>(
                    <div key={'files_'+i} className="file-list">
                      <span>{files.name}</span>
                      <button className="deleteBtn2" onClick={e=>onDeleteFileHandler(e,i)}><img src={deleteIcon} alt=""/></button>
                    </div>
                  ))}
                  <div>
                    <input type="file" name="files" className="fileUpload" style={{width:"90px"}} multiple onChange={e=>onSelectedFilesHandler(e)}/>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn-center">
            <button className="btn line black" style={{width:"100px"}} onClick={(e)=>onUpdateReferenceRoomHandler(e)}>저장</button>
            <Link to={`/Admin/Boards/ReferenceRoomList`} style={{width:"100px"}} className="btn line">목록</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferenceRoomDetail;